import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setTitle } from 'reducers/activecourse/activecourseSlice'
import { Link } from 'react-router-dom'

interface Props {
  title: string
}

const CourseTabSecondNoCaseNumber = (props: Props): JSX.Element => {
  const dispatch = useDispatch()

  useEffect(() => {
    const title = props.title

    dispatch(setTitle(title))
  }, [])

  return (
    <div data-testid='course-tab-no-case-number-content'>
      Your case must be filed with a case number to take the second course. If
      the second course is not available in a couple days,{' '}
      <Link to='/dashboard/lawfirminformation'>contact your attorney</Link>.
    </div>
  )
}

export default CourseTabSecondNoCaseNumber
